module.exports = __webpack_public_path__ + "img/UU_logo.8a68edb8.svg";